module.exports = __webpack_public_path__ + "img/yiyuanxinxi.3618f0f2.png";